import {emitEdapEvent, EVENTS} from '../../utils/emit-edap-event';

function buildEdapPayload({adPlacement, gaiaId, adSrc = '-1', adUci = '-1'}) {
    return {
        ad_placement: adPlacement,
        gaia_id: gaiaId,
        ad_src: adSrc,
        ad_uci: adUci
    };
}

export function emitAdView({adPlacement, gaiaId, adSrc, adUci}) {
    emitEdapEvent(EVENTS.PRESENTED, buildEdapPayload({adPlacement, gaiaId, adSrc, adUci}))
}

export function emitAdFailed({failedReason, adPlacement, gaiaId, adSrc, adUci}) {
    const payload = {
        failed_reason: failedReason,
        ...buildEdapPayload({adPlacement, gaiaId, adSrc, adUci})
    };

    emitEdapEvent(EVENTS.FAILED, payload)
}

export function emitAdSucceeded({adPlacement, gaiaId, adSrc, adUci}) {
    emitEdapEvent(EVENTS.SUCCEEDED, buildEdapPayload({adPlacement, gaiaId, adSrc, adUci}))
}
